<template>
	<div>
		
		<v-row  justify="space-between" class="pt-8">
			<v-col md="4" class="custome-form">
				<v-form ref="raise_issue_form"  lazy-validation  @submit.prevent="raiseIssue()" >
					<div>
						<label>{{$lang.SHIPMENT_ID}}</label>
						<v-text-field
						v-model="shipment_id"
						:placeholder="$lang.SHIPMENT_ID"
						outlined
						dense
						single-line
						@change="getShipmentDetails"
						:rules="$rules.shipmetIdRule"

						></v-text-field>
					</div>

					<div>
						<label>{{$lang.CATEGORY}}</label>

						<v-select
						v-model="catrgory"
						:items="category_list"
						:placeholder="$lang.CATEGORY"
						@focus="getIssueCategory"
						single-line
						outlined
						clearable
						dense
						:loading="category_loading"
						:rules="$rules.categoryRule"
						></v-select>

					</div>
					<div>
						<v-textarea
						v-model="description"
						outlined
						rows="3"
						single-line
						row-height="25"				
						:placeholder="$lang.DESCRIPTION"
						:rules="$rules.descriptionRule"
						></v-textarea>
					</div>

					<v-btn color="primary" class="mt-8 px-4" type="submit" :loading="btn_loding">
						<b>
							{{$lang.CONTINUE}}	
						</b>
					</v-btn>	

				</v-form>
			</v-col>
			<!--  dhipment details -->
			<v-col md="4" class=" border-l" >
				<shipment-details-block :shipment_details="shipment_details" v-if="show_shipment_block" />
			</v-col>
		</v-row>
	</div>
</template>


<script  type="text/javascript" charset="utf-8" async defer>

export default {
	components: {
		ShipmentDetailsBlock :()=>import('./child/ShipmentDetailsBlock.vue'),
	},
	data(){
		return{
			category_loading:false,
			category_list: [],
			shipment_details:{},
			show_shipment_block:false,
			btn_loding:false,

			catrgory:null,
			shipment_id:"",
			description:"",
		}
	},
	created(){
		this.$store.dispatch('drawer/setActiveTab','support-tickets')

		if(this.$route.query.shipment_id){
			this.shipment_id= this.decrypt(this.$route.query.shipment_id)
			this.getShipmentDetails()
		}

	},
	methods:{
		raiseIssue(){
			if (this.$refs.raise_issue_form.validate()==false)
				return false

			const self=this;

			self.btn_loding=true
			var	form = new FormData();
			form.append("shipment_id",self.shipment_id);
			form.append("category",self.catrgory);
			form.append("description",self.description);


			const successHandler = (response) => {
				console.log(response)
				if (response.data.success){
					self.$router.push({name:'support-ticket-details',params:{ticket_id:self.encript(response.data.ticket_id)}})
				}
			};
			const finallyHandler = () => {
				self.btn_loding=false
			};
			
			this.request_POST(self,this.$urls.RAISE_ISSUE,form,successHandler,null,null,finallyHandler)
		},

		/* feching the shipment details*/ 
		getShipmentDetails(){
			const self=this
			let params={
				shipment_id:this.shipment_id,
			};

			const successHandler = (response) => {
				console.log(response)
				if (response.data.success){
					self.shipment_details=response.data.data
					self.show_shipment_block=true
				}else{
					self.show_shipment_block=false
				}

			};
			const finallyHandler = () => {
				// do somrthing
			};

			self.request_GET( self,self.$urls.SHIPMENT_DETAILS,params,successHandler,null,null,finallyHandler)


		},
		getIssueCategory(){
			const self=this
			self.category_loading=true
			let params={};

			const successHandler = (response) => {
				if(response.data.success){
					this.category_list=response.data.ticket_category_list
				}
			};
			const finallyHandler = () => {
				self.category_loading=false
			};

			self.request_GET( self,self.$urls.TICKET_CATEGORY_LIST,params,successHandler,null,null,finallyHandler)

		}


	}
}



</script>